"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SiteVisitsPage;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_leaflet_1 = require("react-leaflet");
const leaflet_1 = __importDefault(require("leaflet"));
require("leaflet/dist/leaflet.css");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_router_dom_1 = require("react-router-dom");
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
const ToolsDate_1 = __importDefault(require("../React/Tools/ToolsDate"));
const CommonComponents_1 = require("../View/Resultsets/CommonComponents");
const PhotoAnnotator_1 = __importDefault(require("./PhotoAnnotator"));
const EMPTY_FILTERS = { dateFrom: "", dateTo: "", text: "" };
const api = (path) => `${MainSetupReact_1.default.serverUrl}${path}`;
// Proxy podglądu zdjęcia przez backend (pliki na GD nie są publiczne).
const photoUrl = (gdFileId) => api(`site-visits/photo/${gdFileId}`);
// Data z bazy (ISO) w czytelnym formacie przez współdzielony moduł dat.
const fmtDate = (v) => ToolsDate_1.default.dateToDDmmmYYYYHHMM(v);
function qs(params) {
    const u = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== "" && v !== null)
            u.append(k, String(v));
    });
    const s = u.toString();
    return s ? `?${s}` : "";
}
function pad(n) {
    return String(n).padStart(2, "0");
}
// 'YYYY-MM-DD HH:mm:ss' w czasie lokalnym urządzenia.
function nowStr() {
    const d = new Date();
    return (`${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`);
}
// Rozpoznawanie mowy (Web Speech API) - dyktowanie opisu (Chrome/secure context).
const SpeechRecognitionCtor = typeof window !== "undefined" &&
    (window.SpeechRecognition || window.webkitSpeechRecognition);
// GPS w chwili dodania zdjęć (best-effort - null gdy odmowa/brak).
function getPosition() {
    return new Promise((resolve) => {
        if (!navigator.geolocation)
            return resolve(null);
        navigator.geolocation.getCurrentPosition((pos) => resolve(pos), () => resolve(null), { enableHighAccuracy: true, timeout: 8000, maximumAge: 10000 });
    });
}
// Manifest PWA "Wizyty na budowie" (osobna instalowalna ikona) - tylko na
// urządzeniach dotykowych i tylko w obrębie tego modułu.
function useVisitsManifest() {
    (0, react_1.useEffect)(() => {
        const isMobile = window.matchMedia("(pointer: coarse)").matches;
        if (!isMobile)
            return;
        const link = document.createElement("link");
        link.rel = "manifest";
        link.href = "visits.webmanifest";
        document.head.appendChild(link);
        return () => {
            document.head.removeChild(link);
        };
    }, []);
}
const NO_ACCESS = { hasAccess: false, isAdmin: false, canLog: false };
function useVisitsAccess() {
    const [access, setAccess] = (0, react_1.useState)(NO_ACCESS);
    (0, react_1.useEffect)(() => {
        fetch(api("site-visits/access"), { credentials: "include" })
            .then((r) => (r.ok ? r.json() : NO_ACCESS))
            .then((d) => setAccess({ ...NO_ACCESS, ...d }))
            .catch(() => { });
    }, []);
    return access;
}
function SiteVisitsPage() {
    const { contractId } = (0, react_router_dom_1.useParams)();
    const location = (0, react_router_dom_1.useLocation)();
    useVisitsManifest();
    (0, react_1.useEffect)(() => {
        document.title = "Wizyty na budowie";
    }, []);
    if (location.pathname.endsWith("/admin"))
        return react_1.default.createElement(VisitsAdmin, null);
    if (location.pathname.endsWith("/list"))
        return react_1.default.createElement(VisitsList, null);
    if (contractId)
        return react_1.default.createElement(CaptureScreen, { contractId: Number(contractId) });
    // Klient przychodzi tu po raporty z wizyt, nie po to, żeby je rejestrować -
    // wejście w zakładkę ma od razu pokazać przegląd, a nie wybór budowy.
    if (MainSetupReact_1.default.isRoleAllowed(["CLIENT"]))
        return react_1.default.createElement(VisitsAdmin, null);
    return react_1.default.createElement(ContractPicker, null);
}
// ----------------------------------------------------------------------------
// Wybór budowy
// ----------------------------------------------------------------------------
function ContractPicker() {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const [contracts, setContracts] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)("");
    const savedMsg = location.state?.savedMsg;
    (0, react_1.useEffect)(() => {
        if (savedMsg)
            window.history.replaceState({}, "");
    }, [location.key]);
    (0, react_1.useEffect)(() => {
        fetch(api("site-visits/contracts"), { credentials: "include" })
            .then((r) => {
            if (r.status === 401 || r.status === 403)
                throw new Error("Brak uprawnień do rejestru wizyt na budowie.");
            if (!r.ok)
                throw new Error("Nie udało się pobrać listy kontraktów.");
            return r.json();
        })
            .then(setContracts)
            .catch((e) => setError(e.message))
            .finally(() => setLoading(false));
    }, []);
    return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-3", style: { maxWidth: 720 } },
        react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center mb-3" },
            react_1.default.createElement("h4", { className: "mb-0" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faHelmetSafety, className: "me-2 text-success" }),
                "Wizyty na budowie"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => navigate("/visits/list") },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faListCheck, className: "me-1" }),
                "Moje wizyty")),
        savedMsg && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success" }, savedMsg),
        error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error),
        loading ? (react_1.default.createElement("div", { className: "text-center py-5" },
            react_1.default.createElement(react_bootstrap_1.Spinner, null))) : contracts.length === 0 && !error ? (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info" }, "Brak przypisanych aktywnych kontrakt\u00F3w do rejestrowania wizyt.")) : (react_1.default.createElement("div", { className: "d-flex flex-column gap-3" },
            react_1.default.createElement("p", { className: "text-muted mb-0" }, "Wybierz budow\u0119, aby doda\u0107 wizyt\u0119:"),
            contracts.map((c) => (react_1.default.createElement(react_bootstrap_1.Card, { key: c.id, className: "shadow-sm", role: "button", onClick: () => navigate(`/visits/${c.id}`) },
                react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "py-3 px-4 d-flex justify-content-between align-items-center" },
                    react_1.default.createElement("div", null,
                        c.ourId ? (
                        // Kontrakt wewnętrzny: OurId · nazwa
                        react_1.default.createElement("div", { className: "fw-bold fs-5" },
                            c.ourId,
                            " \u00B7 ",
                            c.name)) : (
                        // Kontrakt zewnętrzny: nazwa na górze, a pod spodem
                        // mniejszą czcionką "typ numer ➔ powiązany wewnętrzny"
                        // (jak w drzewie "Projekty i zadania").
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "fw-bold fs-5" }, c.name),
                            react_1.default.createElement("div", { className: "text-muted small" },
                                [c.typeName, c.number]
                                    .filter(Boolean)
                                    .join(" "),
                                " ",
                                "\u2794 ",
                                c.ourIdRelated || "Brak powiązania"))),
                        c.cityName && (react_1.default.createElement("div", { className: "text-muted small" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faLocationDot, className: "me-1" }),
                            c.cityName))),
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCirclePlus, className: "text-success ms-3", size: "2x", title: "Dodaj wizyt\u0119" })))))))));
}
// ----------------------------------------------------------------------------
// Ekran rejestracji wizyty (aparat + siatka zdjęć + opis + GPS)
// ----------------------------------------------------------------------------
function CaptureScreen({ contractId }) {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const cameraInputRef = (0, react_1.useRef)(null);
    const galleryInputRef = (0, react_1.useRef)(null);
    const recognitionRef = (0, react_1.useRef)(null);
    const [contractLabel, setContractLabel] = (0, react_1.useState)("");
    const [photos, setPhotos] = (0, react_1.useState)([]);
    const [description, setDescription] = (0, react_1.useState)("");
    const [editing, setEditing] = (0, react_1.useState)(null); // id zdjęcia w edycji
    const [listening, setListening] = (0, react_1.useState)(false);
    const [gpsBusy, setGpsBusy] = (0, react_1.useState)(false);
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const [showHelp, setShowHelp] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)("");
    // Etykieta kontraktu (i re-walidacja dostępu) z listy dostępnych.
    (0, react_1.useEffect)(() => {
        fetch(api("site-visits/contracts"), { credentials: "include" })
            .then((r) => (r.ok ? r.json() : []))
            .then((list) => {
            const c = list.find((x) => x.id === contractId);
            if (!c) {
                setError("Brak dostępu do tego kontraktu.");
                return;
            }
            setContractLabel(`${c.ourId ? c.ourId + " · " : ""}${c.name}`);
        })
            .catch(() => setError("Nie udało się wczytać kontraktu."));
    }, [contractId]);
    // Zwolnij zasoby (podglądy, mikrofon) przy opuszczeniu ekranu.
    (0, react_1.useEffect)(() => {
        return () => {
            photos.forEach((p) => URL.revokeObjectURL(p.url));
            recognitionRef.current?.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    async function onFilesSelected(e) {
        const files = Array.from(e.target.files ?? []);
        e.target.value = ""; // pozwól ponownie wybrać ten sam plik
        if (files.length === 0)
            return;
        setGpsBusy(true);
        const pos = await getPosition();
        setGpsBusy(false);
        const added = files.map((file) => {
            // Czas WYKONANIA (lastModified pliku), nie czas uploadu. Wstawiamy go w
            // nazwę pliku ('YYYY-MM-DD_HH-mm-ss ...'), żeby był widoczny na Dysku
            // niezależnie od tego, kiedy plik trafił na GD (Dysk pokazuje czas uploadu).
            const takenAt = file.lastModified
                ? nowFromEpoch(file.lastModified)
                : nowStr();
            const stamp = takenAt.replace(" ", "_").replace(/:/g, "-");
            const baseName = file.name || "zdjecie.jpg";
            return {
                id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
                file,
                name: `${stamp} ${baseName}`,
                url: URL.createObjectURL(file),
                takenAt,
                lat: pos?.coords.latitude ?? null,
                lon: pos?.coords.longitude ?? null,
                acc: pos?.coords.accuracy ?? null,
            };
        });
        setPhotos((prev) => [...prev, ...added]);
    }
    function removePhoto(id) {
        setPhotos((prev) => {
            const target = prev.find((p) => p.id === id);
            if (target)
                URL.revokeObjectURL(target.url);
            return prev.filter((p) => p.id !== id);
        });
    }
    // Zapis zaznaczeń z anotatora - podmiana bloba na wersję z rysunkiem.
    function onAnnotated(id, blob) {
        setPhotos((prev) => prev.map((p) => {
            if (p.id !== id)
                return p;
            URL.revokeObjectURL(p.url);
            return { ...p, file: blob, url: URL.createObjectURL(blob) };
        }));
        setEditing(null);
    }
    function toggleVoice() {
        if (listening) {
            recognitionRef.current?.stop();
            return;
        }
        if (!SpeechRecognitionCtor) {
            setError("Rozpoznawanie mowy niedostępne w tej przeglądarce.");
            return;
        }
        setError("");
        const rec = new SpeechRecognitionCtor();
        recognitionRef.current = rec;
        rec.lang = "pl-PL";
        rec.interimResults = false;
        rec.maxAlternatives = 1;
        rec.onresult = (ev) => {
            const text = ev.results[0][0].transcript;
            setDescription((prev) => (prev ? `${prev} ${text}` : text));
            rec.stop();
        };
        rec.onerror = (ev) => {
            setListening(false);
            if (ev?.error && ev.error !== "aborted")
                setError(`Błąd mikrofonu: ${ev.error}`);
        };
        rec.onend = () => setListening(false);
        try {
            setListening(true);
            rec.start();
        }
        catch {
            setListening(false);
            setError("Nie udało się uruchomić mikrofonu (wymaga HTTPS i zgody).");
        }
    }
    async function handleSubmit() {
        if (photos.length === 0) {
            setError("Dodaj co najmniej jedno zdjęcie.");
            return;
        }
        setError("");
        setSubmitting(true);
        try {
            const fd = new FormData();
            fd.append("contractId", String(contractId));
            fd.append("description", description);
            fd.append("visitedAt", nowStr());
            fd.append("photosMeta", JSON.stringify(photos.map((p) => ({
                takenAt: p.takenAt,
                latitude: p.lat,
                longitude: p.lon,
                gpsAccuracy: p.acc,
            }))));
            photos.forEach((p) => fd.append("photos", p.file, p.name));
            const res = await fetch(api("site-visits"), {
                method: "POST",
                credentials: "include",
                body: fd,
            });
            if (!res.ok) {
                // Globalny handler serwera zwraca { errorMessage }.
                const msg = await res.json().catch(() => null);
                throw new Error(msg?.errorMessage || msg?.error || "Nie udało się zapisać wizyty.");
            }
            const result = await res.json();
            navigate("/visits", {
                state: {
                    savedMsg: `Zapisano wizytę (${result.photoCount} zdj.).`,
                },
            });
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
        finally {
            setSubmitting(false);
        }
    }
    const editingPhoto = editing ? photos.find((p) => p.id === editing) : null;
    const withGps = photos.filter((p) => p.lat != null).length;
    return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-3", style: { maxWidth: 720 } },
        react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between mb-2" },
            react_1.default.createElement("h5", { className: "mb-0 text-truncate" }, contractLabel || "Wizyta"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "link", className: "p-0 text-muted", title: "Instrukcja", onClick: () => setShowHelp((s) => !s) },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCircleInfo, size: "lg" }))),
        showHelp && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "light", className: "border small" },
            react_1.default.createElement("strong", null, "Jak opisa\u0107 wizyt\u0119:"),
            react_1.default.createElement("ul", { className: "mb-0 ps-3" },
                react_1.default.createElement("li", null, "Zr\u00F3b zdj\u0119cia tego, co istotne - post\u0119p, usterki, uwagi."),
                react_1.default.createElement("li", null, "Jeden opis mo\u017Ce dotyczy\u0107 jednego lub wielu zdj\u0119\u0107."),
                react_1.default.createElement("li", null, "Zapisz swoje spostrze\u017Cenia i wnioski, nie tylko co wida\u0107."),
                react_1.default.createElement("li", null, "Palcem mo\u017Cesz zaznaczy\u0107 miejsce na zdj\u0119ciu (ikona o\u0142\u00F3wka).")))),
        react_1.default.createElement("input", { ref: cameraInputRef, type: "file", accept: "image/*", capture: "environment", hidden: true, onChange: onFilesSelected }),
        react_1.default.createElement("input", { ref: galleryInputRef, type: "file", accept: "image/*", multiple: true, hidden: true, onChange: onFilesSelected }),
        react_1.default.createElement("div", { className: "d-flex gap-2 mb-3" },
            react_1.default.createElement(react_bootstrap_1.Button, { className: "flex-fill py-3", variant: "success", onClick: () => cameraInputRef.current?.click(), disabled: gpsBusy },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCamera, className: "me-2" }),
                "Zr\u00F3b zdj\u0119cie"),
            react_1.default.createElement(react_bootstrap_1.Button, { className: "flex-fill py-3", variant: "outline-success", onClick: () => galleryInputRef.current?.click(), disabled: gpsBusy },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faImages, className: "me-2" }),
                "Z galerii")),
        gpsBusy && (react_1.default.createElement("div", { className: "text-muted small mb-3" }, "Pobieranie lokalizacji\u2026")),
        photos.length > 0 && (react_1.default.createElement("div", { className: "mb-3", style: {
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
                gap: 8,
            } }, photos.map((p) => (react_1.default.createElement("div", { key: p.id, className: "position-relative", style: { aspectRatio: "1 / 1" } },
            react_1.default.createElement("img", { src: p.url, alt: "", style: {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: 6,
                } }),
            react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "dark", className: "position-absolute top-0 end-0 m-1 p-1 lh-1 opacity-75", title: "Usu\u0144 zdj\u0119cie", onClick: () => removePhoto(p.id) },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faXmark })),
            react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "light", className: "position-absolute bottom-0 start-0 m-1 p-1 lh-1 opacity-75", title: "Zaznacz na zdj\u0119ciu", onClick: () => setEditing(p.id) },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faPen })),
            p.lat != null && (react_1.default.createElement("span", { className: "position-absolute bottom-0 end-0 m-1 badge bg-success opacity-75 p-1", title: "Zapisano lokalizacj\u0119 GPS" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faLocationDot })))))))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "d-flex justify-content-between align-items-center" },
                react_1.default.createElement("span", null, "Opis wizyty"),
                SpeechRecognitionCtor && (react_1.default.createElement(react_bootstrap_1.Button, { variant: listening ? "danger" : "outline-primary", size: "sm", onClick: toggleVoice, title: listening ? "Nagrywanie… kliknij, aby zatrzymać" : "Podyktuj opis" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faMicrophone, beatFade: listening })))),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 4, value: description, onChange: (e) => setDescription(e.target.value), placeholder: "Opisz co wida\u0107 i swoje uwagi\u2026 (mo\u017Ce dotyczy\u0107 wielu zdj\u0119\u0107)" })),
        photos.length > 0 && (react_1.default.createElement("div", { className: "small text-muted mb-3" },
            photos.length,
            " zdj. \u00B7 lokalizacja: ",
            withGps,
            "/",
            photos.length)),
        error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error),
        react_1.default.createElement(react_bootstrap_1.Button, { className: "w-100 py-2", onClick: handleSubmit, disabled: submitting || photos.length === 0 }, submitting ? react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm" }) : "Zatwierdź wizytę"),
        editingPhoto && (react_1.default.createElement(PhotoAnnotator_1.default, { src: editingPhoto.url, onSave: (blob) => onAnnotated(editingPhoto.id, blob), onClose: () => setEditing(null) }))));
}
// ----------------------------------------------------------------------------
// Mapa wizyty (leaflet) - pinezka na każde geotagowane zdjęcie
// ----------------------------------------------------------------------------
// Numerowana pinezka (numer = kolejność zdjęcia). divIcon omija problem domyślnych
// ikon leaflet ze ścieżkami przy webpacku i od razu pokazuje, które zdjęcie gdzie.
const numberedIcon = (n) => leaflet_1.default.divIcon({
    className: "",
    html: `<div style="background:#ea4335;color:#fff;border-radius:50%;width:26px;height:26px;display:flex;align-items:center;justify-content:center;font-weight:700;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4)">${n}</div>`,
    iconSize: [26, 26],
    iconAnchor: [13, 13],
});
function FitBounds({ points }) {
    const map = (0, react_leaflet_1.useMap)();
    (0, react_1.useEffect)(() => {
        // Odczekaj aż modal się otworzy, przelicz rozmiar (inaczej szare kafle), dopasuj.
        const t = setTimeout(() => {
            map.invalidateSize();
            if (points.length === 1)
                map.setView(points[0], 16);
            else if (points.length > 1)
                map.fitBounds(points, { padding: [30, 30] });
        }, 150);
        return () => clearTimeout(t);
    }, [map, points]);
    return null;
}
function VisitMap({ photos, onClose }) {
    // Numer pinezki = numer zdjęcia w karcie (indeks w pełnej liście), więc nawet
    // gdy część zdjęć nie ma GPS, numery na mapie zgadzają się z miniaturami.
    const pts = photos
        .map((p, i) => ({ p, n: i + 1 }))
        .filter((x) => x.p.latitude != null && x.p.longitude != null);
    const center = pts.length
        ? [pts[0].p.latitude, pts[0].p.longitude]
        : [52, 19];
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: onClose, fullscreen: true },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, { className: "fs-6" }, "Lokalizacje zdj\u0119\u0107")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, { className: "p-0" },
            react_1.default.createElement(react_leaflet_1.MapContainer, { center: center, zoom: 15, style: { height: "100%", minHeight: "70vh", width: "100%" } },
                react_1.default.createElement(react_leaflet_1.TileLayer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", attribution: "\u00A9 OpenStreetMap" }),
                pts.map(({ p, n }) => (react_1.default.createElement(react_leaflet_1.Marker, { key: p.id, position: [p.latitude, p.longitude], icon: numberedIcon(n) },
                    react_1.default.createElement(react_leaflet_1.Popup, null,
                        react_1.default.createElement("div", { style: { textAlign: "center" } },
                            react_1.default.createElement("div", { className: "small mb-1" },
                                "Zdj\u0119cie ",
                                n),
                            react_1.default.createElement("img", { src: photoUrl(p.gdFileId), alt: "", style: {
                                    width: 140,
                                    height: 140,
                                    objectFit: "cover",
                                    borderRadius: 4,
                                } })))))),
                react_1.default.createElement(FitBounds, { points: pts.map(({ p }) => [p.latitude, p.longitude]) })))));
}
// ----------------------------------------------------------------------------
// Karta wizyty (wspólna dla listy własnej i przeglądu)
// ----------------------------------------------------------------------------
function VisitCard({ visit, showAuthor = false, }) {
    const [showMap, setShowMap] = (0, react_1.useState)(false);
    const [preview, setPreview] = (0, react_1.useState)(null);
    const geoCount = visit._photos?.filter((p) => p.latitude != null && p.longitude != null)
        .length ?? 0;
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: "shadow-sm" },
        react_1.default.createElement(react_bootstrap_1.Card.Body, null,
            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-start" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "fw-bold" }, visit._contractLabel),
                    showAuthor && visit._authorName && (react_1.default.createElement("div", { className: "text-muted small" }, visit._authorName))),
                react_1.default.createElement("div", { className: "text-muted small text-nowrap ms-2" }, fmtDate(visit.visitedAt))),
            visit.description && react_1.default.createElement("div", { className: "small mt-1" }, visit.description),
            visit._photos && visit._photos.length > 0 && (react_1.default.createElement("div", { className: "mt-2", style: { display: "flex", gap: 6, flexWrap: "wrap" } }, visit._photos.map((ph, i) => (react_1.default.createElement("div", { key: ph.id, className: "position-relative", role: "button", onClick: () => setPreview(ph), title: ph.takenAt
                    ? `Zrobiono: ${fmtDate(ph.takenAt)}`
                    : "Podgląd zdjęcia" },
                react_1.default.createElement("img", { src: photoUrl(ph.gdFileId), alt: ph.fileName ?? "", loading: "lazy", style: {
                        width: 84,
                        height: 84,
                        objectFit: "cover",
                        borderRadius: 4,
                        display: "block",
                    } }),
                react_1.default.createElement("span", { className: `position-absolute bottom-0 end-0 m-1 badge rounded-pill ${ph.latitude != null ? "bg-danger" : "bg-secondary"}`, style: { fontSize: "0.7rem" } }, i + 1)))))),
            react_1.default.createElement("div", { className: "mt-2 d-flex align-items-center gap-3" },
                visit._gdFolderUrl && (react_1.default.createElement(CommonComponents_1.GDFolderIconLink, { layout: "horizontal", folderUrl: visit._gdFolderUrl })),
                geoCount > 0 && (react_1.default.createElement(CommonComponents_1.MapIconButton, { layout: "horizontal", onClick: () => setShowMap(true) }))),
            showMap && (react_1.default.createElement(VisitMap, { photos: visit._photos ?? [], onClose: () => setShowMap(false) })),
            preview && (react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: () => setPreview(null), centered: true, size: "lg" },
                react_1.default.createElement(react_bootstrap_1.Modal.Body, { className: "p-0 bg-dark text-center" },
                    react_1.default.createElement("img", { src: photoUrl(preview.gdFileId), alt: preview.fileName ?? "", style: {
                            maxWidth: "100%",
                            maxHeight: "85vh",
                            objectFit: "contain",
                        } })))))));
}
// Pasek filtrów - te same prymitywy co inne FilterBody w projekcie (Form.Group/Col
// + Form.Control type text/date), bez osobnego widgetu.
function FiltersBar({ value, onChange, }) {
    const set = (patch) => onChange({ ...value, ...patch });
    return (react_1.default.createElement(react_bootstrap_1.Row, { className: "g-2 mb-3 align-items-end" },
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, xs: 12, md: true },
            react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-0 small" }, "Szukana fraza"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { size: "sm", placeholder: "Opis / kontrakt", value: value.text, onChange: (e) => set({ text: e.target.value }) })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, xs: 6, md: "auto" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-0 small" }, "Od"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", size: "sm", value: value.dateFrom, onChange: (e) => set({ dateFrom: e.target.value }) })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, xs: 6, md: "auto" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-0 small" }, "Do"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", size: "sm", value: value.dateTo, onChange: (e) => set({ dateTo: e.target.value }) })),
        react_1.default.createElement(react_bootstrap_1.Col, { xs: "auto" },
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => onChange(EMPTY_FILTERS) }, "Wyczy\u015B\u0107"))));
}
// ----------------------------------------------------------------------------
// Lista moich wizyt (z filtrami)
// ----------------------------------------------------------------------------
function VisitsList() {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [visits, setVisits] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)("");
    const [filters, setFilters] = (0, react_1.useState)(defaultDateFilters);
    const { isAdmin, canLog } = useVisitsAccess();
    (0, react_1.useEffect)(() => {
        setLoading(true);
        fetch(api(`site-visits${qs(filters)}`), { credentials: "include" })
            .then((r) => {
            if (!r.ok)
                throw new Error("Nie udało się pobrać wizyt.");
            return r.json();
        })
            .then(setVisits)
            .catch((e) => setError(e.message))
            .finally(() => setLoading(false));
    }, [filters]);
    return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-3", style: { maxWidth: 720 } },
        react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center mb-3" },
            react_1.default.createElement("h4", { className: "mb-0" }, "Moje wizyty"),
            react_1.default.createElement("div", { className: "d-flex gap-2" },
                isAdmin && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-primary", size: "sm", onClick: () => navigate("/visits/admin") }, "Przegl\u0105d")),
                canLog && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", size: "sm", onClick: () => navigate("/visits") },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCamera, className: "me-1" }),
                    "Nowa wizyta")))),
        react_1.default.createElement(FiltersBar, { value: filters, onChange: setFilters }),
        error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error),
        loading ? (react_1.default.createElement("div", { className: "text-center py-5" },
            react_1.default.createElement(react_bootstrap_1.Spinner, null))) : visits.length === 0 ? (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info" }, "Brak wizyt dla wybranych filtr\u00F3w.")) : (react_1.default.createElement("div", { className: "d-flex flex-column gap-3" }, visits.map((v) => (react_1.default.createElement(VisitCard, { key: v.id, visit: v })))))));
}
// ----------------------------------------------------------------------------
// Przegląd wizyt dla ról 1/2 (grupowanie po osobie/kontrakcie + drill-down)
// ----------------------------------------------------------------------------
function ymd(d) {
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
// Widoki startują z ostatnich 30 dni (od 30 dni wstecz do dziś).
function defaultDateFilters() {
    return {
        dateFrom: ymd(ToolsDate_1.default.addDays(new Date(), -30)),
        dateTo: ymd(new Date()),
        text: "",
    };
}
function VisitsAdmin() {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const [groupBy, setGroupBy] = (0, react_1.useState)("person");
    const [filters, setFilters] = (0, react_1.useState)(defaultDateFilters);
    const [summary, setSummary] = (0, react_1.useState)([]);
    const [visits, setVisits] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)("");
    const [denied, setDenied] = (0, react_1.useState)(false);
    const { canLog } = useVisitsAccess();
    // Zaznaczona grupa trzymana w URL (?person= / ?contract=) - dzięki temu
    // systemowe/przeglądarkowe "wstecz" wraca do listy grup, bez własnej strzałki.
    const selectedGroupBy = searchParams.get("contract")
        ? "contract"
        : searchParams.get("person")
            ? "person"
            : null;
    const selectedKey = selectedGroupBy
        ? Number(searchParams.get(selectedGroupBy))
        : null;
    (0, react_1.useEffect)(() => {
        setLoading(true);
        fetch(api(`site-visits/admin/summary${qs({ groupBy, ...filters })}`), {
            credentials: "include",
        })
            .then((r) => {
            if (r.status === 401 || r.status === 403) {
                setDenied(true);
                return [];
            }
            if (!r.ok)
                throw new Error("Nie udało się pobrać podsumowania.");
            return r.json();
        })
            .then(setSummary)
            .catch((e) => setError(e.message))
            .finally(() => setLoading(false));
    }, [groupBy, filters]);
    (0, react_1.useEffect)(() => {
        if (selectedKey == null || !selectedGroupBy)
            return;
        setLoading(true);
        const key = selectedGroupBy === "person"
            ? { personId: selectedKey }
            : { contractId: selectedKey };
        fetch(api(`site-visits/admin${qs({ ...key, ...filters })}`), {
            credentials: "include",
        })
            .then((r) => {
            if (!r.ok)
                throw new Error("Nie udało się pobrać wizyt.");
            return r.json();
        })
            .then(setVisits)
            .catch((e) => setError(e.message))
            .finally(() => setLoading(false));
    }, [selectedKey, selectedGroupBy, filters]);
    function chooseGroupBy(g) {
        setSearchParams({}); // zmiana grupowania wychodzi z drill-downu
        setGroupBy(g);
    }
    if (denied)
        return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-3", style: { maxWidth: 720 } },
            react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Brak uprawnie\u0144 do przegl\u0105du wizyt.")));
    return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-3", style: { maxWidth: 720 } },
        react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center mb-3" },
            react_1.default.createElement("h4", { className: "mb-0" }, "Przegl\u0105d wizyt"),
            canLog && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => navigate("/visits/list") }, "Moje wizyty"))),
        react_1.default.createElement(react_bootstrap_1.ButtonGroup, { className: "mb-3 w-100" },
            react_1.default.createElement(react_bootstrap_1.Button, { variant: groupBy === "person" ? "primary" : "outline-primary", onClick: () => chooseGroupBy("person") }, "Wg os\u00F3b"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: groupBy === "contract" ? "primary" : "outline-primary", onClick: () => chooseGroupBy("contract") }, "Wg kontrakt\u00F3w")),
        react_1.default.createElement(FiltersBar, { value: filters, onChange: setFilters }),
        error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error),
        selectedKey != null ? (loading ? (react_1.default.createElement("div", { className: "text-center py-4" },
            react_1.default.createElement(react_bootstrap_1.Spinner, null))) : visits.length === 0 ? (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info" }, "Brak wizyt.")) : (react_1.default.createElement("div", { className: "d-flex flex-column gap-3" }, visits.map((v) => (react_1.default.createElement(VisitCard, { key: v.id, visit: v, showAuthor: true })))))) : loading ? (react_1.default.createElement("div", { className: "text-center py-5" },
            react_1.default.createElement(react_bootstrap_1.Spinner, null))) : summary.length === 0 ? (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info" }, "Brak wizyt dla wybranych filtr\u00F3w.")) : (react_1.default.createElement("div", { className: "d-flex flex-column gap-2" }, summary.map((g) => (react_1.default.createElement(react_bootstrap_1.Card, { key: g.groupKey, role: "button", className: "shadow-sm", onClick: () => setSearchParams({ [groupBy]: String(g.groupKey) }) },
            react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "d-flex justify-content-between align-items-center py-2 px-3" },
                react_1.default.createElement("span", { className: "fw-semibold" }, g.label),
                react_1.default.createElement(react_bootstrap_1.Badge, { bg: "primary", pill: true }, g.count)))))))));
}
// 'YYYY-MM-DD HH:mm:ss' z epoch ms (czas lokalny).
function nowFromEpoch(ms) {
    const d = new Date(ms);
    return (`${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`);
}
